import { useEffect, useState } from 'react'

import { DragDropData, DragDropListsEvents } from '../dtos'

export interface OnDataChangedProps {
    data: DragDropData
    onDataChangedServer?: DragDropListsEvents['onDataChanged']
    state: DragDropData
}

export const useOnDataChanged = ({
    data,
    onDataChangedServer,
    state
}: OnDataChangedProps) => {
    const [isDataLoading, setIsDataLoading] = useState(true)

    // After data loaded
    useEffect(() => {
        setIsDataLoading(false)
    }, [])

    // Dispatch onDataChanged in case you need to get the full data object
    useEffect(() => {
        if (data && onDataChangedServer && !isDataLoading) {
            onDataChangedServer(state)
        }
    }, [JSON.stringify(state), isDataLoading])
}
